import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import Select from "../common/Select";
import { createDeepEqualSelector, mapToSelectValues } from "./utils";

function AdvertisementTypes({advertisementTypes = [], disabled, value = [], onChange, placeholder, ...others}) {

    const _value = mapToSelectValues(value, null, advertisementTypes);
    return (
        <Select
            {...others}
            placeholder={placeholder || "Finalized Status "}
            value={_value}
            multiple
            disabled={disabled}
            defaultMenuPortalTarget
            onChange={onChange}
            options={advertisementTypes}
        />
    );
}
AdvertisementTypes.propTypes = {
    advertisementTypes: PropTypes.array,
    value: PropTypes.array,
    disabled: PropTypes.bool,
    onChange: PropTypes.func,
    placeholder: PropTypes.string,
};

const selector = createDeepEqualSelector(
    (state) => state.globalApp.advertisementTypes,
    (advertisementTypes) => {
        const advTypes = mapToSelectValues(advertisementTypes);
        return { advertisementTypes: advTypes };
    }
);

AdvertisementTypes.propTypes = {
    advertisementTypes: PropTypes.array,
    value: PropTypes.array,
};



export default connect((state) => selector(state))(AdvertisementTypes);
